import { Outlet } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import ScrollToTop from "./ScrollToTop";
import { LinkedInTracking } from "./LinkedInTracking";
import { GA4Tracking } from "./GA4Tracking";
import { DemoModalProvider } from "@/context/DemoModalContext";
import { DemoRequestModal } from "./DemoRequestModal";
import { AnnouncementBanner } from "./AnnouncementBanner";
import Footer from "./Footer";
import { SEOHead } from "./SEOHead";

const queryClient = new QueryClient();

export default function RootLayout() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <DemoModalProvider>
          {/* Default document head for every route. Any page that renders its own
              <SEOHead> overrides this (react-helmet-async: the nested/later title
              and meta win), so specific pages keep their own titles while orphaned
              or utility routes fall back to a branded default instead of an empty
              <title>. Deliberately sets NO canonical here — a site-wide canonical
              would point every page at one URL, which is the bug this work fixed. */}
          <SEOHead
            title="Meshly — The AI verification layer"
            description="Meshly is the AI verification layer for the systems your business runs on. It watches them, catches when they go out of sorts, and proves what your people and your agents actually did. We start at revenue."
          />
          <Toaster />
          <Sonner />
          <ScrollToTop />
          <LinkedInTracking partnerId="7441324" />
          <GA4Tracking />
          <DemoRequestModal />
          <AnnouncementBanner />
          <Outlet />
          <Footer />
        </DemoModalProvider>
      </TooltipProvider>
    </QueryClientProvider>
  );
}
